import React, { useState } from 'react';
import { LeadsFormCapture } from './LeadsFormCapture';
import { LeadsSuccessPopup } from './LeadsSuccessPopup';

interface LeadsCaptureProps {
  leadCaptureFormId: string;
  projectId?: number;
  onClickRegisterButton?: () => void;
}

export const LeadsCapture: React.FC<LeadsCaptureProps> = ({
  leadCaptureFormId,
  projectId,
  onClickRegisterButton,
}) => {
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const updateSuccessPopup = (value: boolean) => {
    setShowSuccessPopup(value);
    if (onClickRegisterButton) {
      onClickRegisterButton();
    }
  };
  return (
    <>
      {showSuccessPopup ? (
        <LeadsSuccessPopup updateSuccessPopup={updateSuccessPopup} />
      ) : (
        <LeadsFormCapture
          leadCaptureFormId={leadCaptureFormId}
          projectId={projectId}
          updateSuccessPopup={updateSuccessPopup}
        />
      )}
    </>
  );
};
